import DetailProfilePartner from "../../Components/Admin/ProfilePartner";

const ProfilesPartner = () => {
  return (
    <>

      <DetailProfilePartner />


    </>
  );
};

export default ProfilesPartner;
